import yousers from '@yola/yousersjs';

const updateUserPreference = (name, value) => {
  yousers.preferences().put(name, value).catch(console.error);
};

export default updateUserPreference;
